import { UserInterface } from '../../../interfaces/dto/user/user-interface';

export class UserModel implements UserInterface {
  active: boolean = false;
  address: string = '';
  agentCode: string = '';
  canUpdate: boolean = false;
  email: string = '';
  fax: string = '';
  id: number = -1;
  location: string = '';
  name: string = '';
  partnership: string = '';
  phone: string = '';
  postalCode: string = '';
  profileDescription: string = '';
  state: string = '';
  username: string = '';
  fiscalNumber?: string = '';
  iban?: string = '';
}
